<template>
  <a-date-picker v-if="permission" v-model="value" style="min-width: auto" show-time value-format="YYYY-MM-DD HH:mm:ss" :disabled-date="disabledDate" @ok="onOk">
    <span class="edit-story-date">{{ value || '--' }}</span>
  </a-date-picker>
  <span v-else class="story-date">{{ value || '--' }}</span>
</template>
<script>
import moment from 'moment';
import { reviewUpdateItem } from '@/api/project/review';

export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    itemName: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      value: null,
      projectId: parseInt(this.$route.params.project_id) || null,
      isEdit: false,
      open: false
    };
  },
  computed: {
    permission() {
      // return permissionRequired('project:requirement:edit', this.projectId);
      return true;
    }
  },
  watch: {
    dataSource() {
      this.setValue();
    }
  },
  created() {
    this.setValue();
  },
  methods: {
    setValue() {
      if (this.itemName === 'review_time') {
        this.value = this.dataSource.review_time;
      }
    },
    onOk() {
      reviewUpdateItem({
        review_id: this.dataSource.id,
        project_id: this.projectId,
        key: this.itemName,
        value: this.value
      }).then(() => {
        this.isEdit = false;
        this.$message.success('更新成功');
        this.$emit('change');
      });
    },

    disabledDate(value) {
      if (this.itemName === 'start_time') {
        const tagetValue = moment(this.dataSource.end_time);
        if (!value || !tagetValue) {
          return false;
        }
        return value.valueOf() > tagetValue.valueOf();
      } else if (this.itemName === 'end_time') {
        const tagetValue = moment(this.dataSource.start_time);
        if (!value || !tagetValue) {
          return false;
        }
        return value.valueOf() < tagetValue.valueOf();
      } else {
        return false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.story-date {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
}
.edit-story-date {
  cursor: pointer;
  display: block;
  line-height: 22px;
  padding: 0 4px;
}
.edit-story-date:hover {
  background-color: #e4e4e4;
}
</style>
